import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/helpers/utils";

const badge = cva("inline-flex items-center px-2 py-1 font-medium", {
  variants: {
    color: {
      gray: "text-gray-700 bg-gray-50",
      white: "text-gray-700 bg-white",
      primary: "text-primary bg-primary-50",
      secondary: "text-secondary-600 bg-secondary-50",
      red: "text-red bg-red-50",
      yellow: "text-yellow bg-yellow-50",
      green: "text-green bg-green-50",
      blue: "text-blue bg-blue-50",
    },
    size: {
      sm: "text-xs space-x-1",
      base: "text-sm space-x-2",
    },
    bordered: {
      true: "ring-1 ring-inset ring-current",
    },
    pill: {
      true: "rounded-full",
      false: "rounded-md",
    },
  },
  defaultVariants: { color: "gray", size: "sm", pill: false, bordered: false },
});

export interface BadgeProps extends VariantProps<typeof badge> {
  className?: string;
  children: React.ReactNode;
}

export const Badge = ({
  children,
  color,
  size,
  bordered,
  pill,
  className,
  ...props
}: BadgeProps) => {
  return (
    <span
      {...props}
      className={cn(badge({ color, size, bordered, pill }), className)}
    >
      {children}
    </span>
  );
};
